import IMAGES from "../assets/IMAGES";

export const ProductArr = [
  {
    TITLE: "GREYT SPACE",
    TITLE2: "GreytSpace",
    PATH: "/product?name=greyt-space",
    DETAILS: {
      TITLE: "The Future is Here: An Overview on Greyt Space",
      PROJECT_NAME: "GREYTSPACE",
      PROJECT_IMG: IMAGES.GreytSpace_IMG,
      PROJECT_URL: "https://greytspace.com/",
      OVER_VIEW: [
        {
          SUB_TITLE:
            "Greyt Space meeting room booking application is designed to simplify the entire booking process for companies, ensuring seamless coordination and efficient use of meeting spaces.",
        },
        {
          SUB_TITLE:
            "GreytSpace streamlines the process of reserving meeting rooms, eliminating scheduling conflicts and enhancing workplace efficiency. It provides real-time availability updates, allowing employees to book rooms instantly.",
        },
        {
          SUB_TITLE:
            "The platform integrates with calendar systems, sends automated reminders, and offers detailed usage reports to optimize room utilization.",
        },
        {
          SUB_TITLE:
            "GreytSpace is ideal for companies looking to enhance collaboration, minimize administrative overhead, and ensure that their meeting spaces are used to their full potential.",
        },
      ],
      KEY_BENEFITS: [
        {
          SUB_BENEFIT:
            "Effortless booking: users can quickly login and book meeting rooms in just a few clicks",
        },
        {
          SUB_BENEFIT:
            "Multi Level Approval System: Bookings follow a streamlined approval process, ensuring oversight from Admin to Building Manager.",
        },
        {
          SUB_BENEFIT:
            "Automated Billing : Generate automated invoices every month",
        },
        {
          SUB_BENEFIT:
            "Transparent Billing Details : View billing information, including hours booked by company employees, to maintain transparency and accuracy",
        },
        {
          SUB_BENEFIT:
            "Quick Setup : Easy integration with your existing systems and tools",
        },
        {
          SUB_BENEFIT: "Booking Platforms: Book in MS Teams, Web & Mobile",
        },
      ],
    },
    DESCRIPTION:
      "Greyt Space meeting room booking application is designed to simplify the entire booking process for companies, ensuring seamless coordination and efficient use of meeting spaces.",
  },
  {
    TITLE: "SUPPORT HELP DESK",
    TITLE2: "Support Help Desk",
    PATH: "/product?name=support-help-desk",
    DETAILS: {
      TITLE: "The Future is Here: An Overview on Support Help Desk",
      PROJECT_NAME: "SUPPORT HELP DESK",
      PROJECT_IMG: IMAGES.support_help_desk,
      STYLE: {
        width: 500,
        height: 500,
      },
      PROJECT_URL: "",
      OVER_VIEW: [
        {
          SUB_TITLE:
            "Support Help desk is a robust project management and issue tracking software designed to streamline SAP and software development projects.",
        },
        {
          SUB_TITLE:
            "It offers customizable workflows, enabling teams to plan and manage issues with ease while ensuring timely resolution. ",
        },
        {
          SUB_TITLE:
            "The platform promotes real-time collaboration, enhancing communication between teams and clients, and provides a centralized dashboard for tracking project timelines and issue statuses.",
        },
        {
          SUB_TITLE:
            "Automated alerts keep all stakeholders informed of important updates, minimizing manual intervention. With seamless integration into SAP, BetaCode ensures accurate data synchronization and project reporting.",
        },
        {
          SUB_TITLE:
            "The tool also features comprehensive reporting capabilities, offering insights into key performance indicators, and its scalable architecture supports organizations of any size, making it the perfect solution for effective project management.",
        },
      ],
      KEY_BENEFITS: [
        {
          SUB_BENEFIT:
            "Customizable Workflow: Allows teams to set up project-specific workflows, ensuring seamless tracking and resolution of issues.",
        },
        {
          SUB_BENEFIT:
            "Real-time Collaboration: Facilitates efficient communication between team members and clients, enhancing transparency and accountability.",
        },
        {
          SUB_BENEFIT:
            "Centralized Dashboard: Provides an intuitive, user-friendly interface to view project timelines, issue statuses, and priorities at a glance.",
        },
        {
          SUB_BENEFIT:
            "Automated Alerts: Notifies teams and stakeholders of important updates and deadlines, reducing manual follow-ups.",
        },
        {
          SUB_BENEFIT:
            "Integrated with SAP: Ensures smooth synchronization of project data with SAP systems, allowing for accurate project reporting and insights.",
        },
        {
          SUB_BENEFIT:
            "Comprehensive Reporting: Offers advanced reporting and analytics tools to monitor project performance and track KPIs.",
        },
        {
          SUB_BENEFIT:
            "Scalable Architecture: Adapts to the growing needs of organizations, supporting large-scale project management effortlessly.",
        },
      ],
    },
    DESCRIPTION:
      "Support Help desk is a robust project management and issue tracking software designed to streamline SAP and software development projects, customizable workflows.",
  },
  {
    TITLE: "ACCOUNTANT",
    TITLE2: "Accountant",
    PATH: "/product?name=accountant",
    DETAILS: {
      TITLE: "The Future is Here: An Overview on Accountant Mobile App",
      PROJECT_NAME: "ACCOUNTANT",
      PROJECT_IMG: IMAGES.accountant,
      PROJECT_URL:
        "https://play.google.com/store/apps/details?id=com.Accountant&hl=en_IN",
      OVER_VIEW: [
        {
          SUB_TITLE:
            "The finance app is designed to help financial agents efficiently manage and maintain client-related data and financial transactions.",
        },
        {
          SUB_TITLE:
            "It provides a user-friendly interface and robust features for tracking and recording various aspects of client interactions. ",
        },
        {
          SUB_TITLE:
            "The app helps maintain client profiles and provides secure platform for uploading, storing, downloading KYC documents. ",
        },
        {
          SUB_TITLE:
            "Agents can record and monitor all financial transactions, including deposits, withdrawals, investments and commission payments.",
        },
        {
          SUB_TITLE:
            "This helps ensure accurate and transparent financial tracking. The app automatically calculates, and records commissions earned by agents",
        },
      ],
      KEY_BENEFITS: [
        {
          SUB_BENEFIT:
            "Efficient Client Management: Streamlines client data and financial transactions.",
        },
        {
          SUB_BENEFIT:
            "Secure KYC Storage: Safely uploads and stores KYC documents.",
        },
        {
          SUB_BENEFIT:
            "Comprehensive Tracking: Monitors deposits, withdrawals, investments, and commissions.",
        },
        {
          SUB_BENEFIT:
            "Automatic Calculations: Calculates and records commissions for accurate financial tracking.",
        },
        {
          SUB_BENEFIT:
            "Transaction Recording: Keeps detailed records of all financial activities.",
        },
        {
          SUB_BENEFIT:
            "Real-Time Updates: Provides immediate updates on transactions and commissions.",
        },
        {
          SUB_BENEFIT:
            "Data Security: Ensures secure handling of sensitive financial information.",
        },
      ],
    },
    DESCRIPTION:
      " The finance app streamlines client data and transactions, offering secure KYC storage, transaction tracking, and automatic commission calculations for accurate and transparent financial management.",
  },

  // {
  //   TITLE: "PAYMENT DASHBOARD",
  //   TITLE2: "Payment Dashboard",
  //   PATH: "/product?name=payment-dashboard",
  //   DETAILS: {
  //     TITLE: "Gateway to Streamlined Financial Operations",
  //     PROJECT_NAME: "PAYMENT DASHBOARD",
  //     PROJECT_IMG: IMAGES.PaymentDashboardImg,
  //     STYLE: {
  //       width: 500,
  //       height: 500,
  //     },
  //     PROJECT_URL: "https://greytspace.com/",
  //     OVER_VIEW: [
  //       {
  //         SUB_TITLE:
  //           "Introducing the Payment Dashboard: A cutting-edge financial application meticulously crafted to revolutionize payment scheduling for businesses across all scales. This innovative platform offers a seamless solution, simplifying the intricate task of managing vendor payments through an intuitive drag-and-drop interface seamlessly integrated with calendar systems.",
  //       },
  //       {
  //         SUB_TITLE:
  //           "By empowering users to visually organize and schedule payments, the Payment Dashboard ensures timely transactions, optimizes cash flow management, and elevates financial planning to new heights of efficiency and effectiveness.",
  //       },
  //       {
  //         SUB_TITLE:
  //           "From enhancing customer engagement to boosting productivity, chatbots are leading the way towards a more streamlined future in business operations. ",
  //       },
  //       {
  //         SUB_TITLE:
  //           "Users can effortlessly schedule payments by dragging them into the desired dates on an interactive calendar. This visual approach to payment management makes planning and rescheduling payments straightforward and error-free.",
  //       },
  //     ],
  //     KEY_BENEFITS: [
  //       {
  //         SUB_BENEFIT: "Simplified Payment Scheduling",
  //       },
  //       {
  //         SUB_BENEFIT: "Seamless Vendor Management",
  //       },
  //       {
  //         SUB_BENEFIT: "Timely Payment Reminders",
  //       },
  //       {
  //         SUB_BENEFIT: "Insightful Financial Reporting",
  //       },
  //       {
  //         SUB_BENEFIT: "Enhanced Security",
  //       },
  //     ],
  //   },
  //   DESCRIPTION:
  //     "Say goodbye to payment scheduling hassles with our advanced payment dashboard. Streamline your business operations, automate processes, reduce errors, and gain real-time insights for decision-making",
  // },
  {
    TITLE: "CUSTOMER RELATIONS MANAGEMENT",
    TITLE2: "Customer Relations Management",

    PATH: "/product?name=contact-management",
    DETAILS: {
      TITLE: "Centralize, Automate, and Grow with Betacode CRM",
      PROJECT_NAME: "CUSTOMER RELATIONS MANAGEMENT",
      PROJECT_IMG: IMAGES.supportPeople,
      STYLE: {
        width: "100%",
        height: 500,
        objectFit: "cover",
      },
      PROJECT_URL: "https://cms.betacodeinfotech.com/",
      OVER_VIEW: [
        {
          SUB_TITLE:
            "Betacode CRM offers a comprehensive suite of features tailored for businesses looking to streamline contact management, meeting scheduling, and communication workflows. It includes intelligent lead tracking, real-time reporting, customizable dashboards, and an advanced bulk email campaign tool—its standout feature. ",
        },
        {
          SUB_TITLE:
            "The platform also supports domain warm-up, virtual machine hosting, and seamless integration with popular tools. With a user-friendly interface and automation capabilities, Betacode CRM helps teams stay organized, improve engagement, and drive measurable results.",
        },
        {
          SUB_TITLE:
            "Its robust bulk email engine helps teams launch high-impact campaigns, manage domain reputation, and monitor open and click rates.",
        },
        {
          SUB_TITLE:
            "With built-in analytics, businesses gain actionable insights into customer behavior, sales performance, and campaign effectiveness.",
        },
      ],
      KEY_BENEFITS: [
        {
          SUB_BENEFIT:
            "Centralized Contact Data: Organizes and manages client contact information efficiently.",
        },
        {
          SUB_BENEFIT:
            "Email campaign feature enabling sending personalized, high-deliverability bulk emails at scale with real-time tracking, automation, and domain warm-up etc.",
        },
        {
          SUB_BENEFIT:
            "WhatsApp Integration: Integrated with third-party services for seamless WhatsApp communication.",
        },
        {
          SUB_BENEFIT:
            "Microsoft Teams Integration: Allows employees to access the application directly through Microsoft Teams.",
        },
        {
          SUB_BENEFIT:
            "Collaboration: Enables smooth collaboration across the organization for unified client outreach.",
        },
        {
          SUB_BENEFIT:
            "Enhanced Productivity: Streamlines contact management and communication tasks to boost employee efficiency.",
        },
      ],
    },
    DESCRIPTION:
      "CMS helps organizations manage client data for promotions and brand campaigns via emails and WhatsApp, integrated with third-party services and Microsoft Teams, enabling seamless access for employees.",
  },
  {
    TITLE: "Vendor Management",
    TITLE2: "Vendor Management",

    PATH: "/product?name=vendor-management",
    DETAILS: {
      TITLE: "Streamlines the onboarding new vendors and customers ",
      PROJECT_NAME: "VENDOR MANAGEMENT",
      PROJECT_IMG: IMAGES.connectPeople,
      STYLE: {
        width: "100%",
        height: 500,
        objectFit: "cover",
      },
      PROJECT_URL: "",
      OVER_VIEW: [
        {
          SUB_TITLE:
            "Provides a centralized view of vendor/customer records, eliminating duplicates and ensuring that all departments are working with up-to-date information.",
        },
        {
          SUB_TITLE:
            "Streamlines the process of onboarding new vendors and customers by collecting, validating, and approving master data (like contact details, tax information, and banking details) in a structured manner.",
        },
        {
          SUB_TITLE:
            "Automatically validates vendor and customer data against external sources (e.g., government databases, tax registries) to ensure accuracy before onboarding.",
        },
        {
          SUB_TITLE:
            "Syncs master data between the Supplier Management System and SAP, so that changes or updates (such as vendor addresses or customer contract terms) are reflected in real-time",
        },
      ],
      KEY_BENEFITS: [
        {
          SUB_BENEFIT: "Onboarding Process Automation",
        },
        {
          SUB_BENEFIT: "Data Validation and Standardization",
        },
        {
          SUB_BENEFIT: "Integration with SAP for Master Data Maintenance",
        },
        {
          SUB_BENEFIT: "Enhanced Master Data Governance",
        },
        {
          SUB_BENEFIT: "Vendor/Customer Relationship Management",
        },
        {
          SUB_BENEFIT: "Risk Mitigation",
        },
        {
          SUB_BENEFIT: "Reports and Analytics",
        },
      ],
    },
    DESCRIPTION:
      "Supplier Management is essential for ensuring that the core data within an organization, such as vendor or customer information, is accurate and consistent across all systems. In the case of your Supplier Management tool integrated with SAP",
  },
  {
    TITLE: "TIMESHEET",
    PATH: "/product?name=timesheet",
    TITLE2: "Timesheet",
    DETAILS: {
      TITLE: "Your Ultimate Resource Management Solution",
      PROJECT_NAME: "TIMESHEET",
      PROJECT_IMG: IMAGES.timesheet,
      STYLE: {
        width: 500,
        height: 500,
      },
      PROJECT_URL: "",
      OVER_VIEW: [
        {
          SUB_TITLE:
            "Timesheet revolutionizes resource management by offering precise project and task time tracking, effortless time management, and insightful data analytics. ",
        },
        {
          SUB_TITLE:
            "With Timesheet, businesses can make informed decisions, foster employee development, and enhance productivity, ultimately maximizing the impact of their workforce on project success and business growth.",
        },
        {
          SUB_TITLE:
            "Timesheet stands as an invaluable asset for high-level management and employees alike, offering a clear overview of time allocation and contributing to informed decision-making and individual growth.",
        },
        {
          SUB_TITLE:
            "Accurately track time for every project and task, facilitating precise resource allocation and billing.",
        },
      ],
      KEY_BENEFITS: [
        {
          SUB_BENEFIT: "Project & Task Time Tracking",
        },
        {
          SUB_BENEFIT: "Effortless Time Management",
        },
        {
          SUB_BENEFIT: "Insightful Data Analytics",
        },
        {
          SUB_BENEFIT:
            "Timesheet Enhances Productivity, Efficiency & Resource Management",
        },
        {
          SUB_BENEFIT: "Enhanced Security",
        },
      ],
    },
    DESCRIPTION:
      "Unlock your team’s potential with Timesheet, a cutting-edge resource management app. Track time for projects and tasks efficiently, boosting productivity, accountability, and optimizing overall performance.",
  },

  {
    TITLE: "WHATSAPP SERVICES",
    TITLE2: "WhatsApp Services",
    PATH: "/product?name=whatsapp-services",
    DETAILS: {
      TITLE: "Take Your Business to Uncharted Heights",
      PROJECT_NAME: "WhatsApp Services",
      PROJECT_IMG: IMAGES.WhatsappServices,
      STYLE: {
        // width: 500,
        // height: 500,
      },
      PROJECT_URL: "",
      OVER_VIEW: [
        {
          SUB_TITLE:
            "WhatsApp has become a widely-used social network, captivating users worldwide with its diverse features and user-friendly interface. ",
        },
        {
          SUB_TITLE:
            "Recognizing its immense potential, businesses are harnessing its power to transform their communication strategies and engage with customers more effectively.",
        },
        {
          SUB_TITLE:
            "This brings us to WhatsApp webhooks and business verification, that can lead to seamless integration and verified security whilst ensuring peace of mind.",
        },
        {
          SUB_TITLE:
            "Our WhatsApp services are all about enabling our business to connect with customers on the world’s most popular messaging platform, providing a secure and interactive communication experience that drives engagement and fosters trust.",
        },
      ],
      KEY_BENEFITS: [
        {
          SUB_BENEFIT: "Real-time Updates",
        },
        {
          SUB_BENEFIT: "Automated Efficiency",
        },
        {
          SUB_BENEFIT: "Personalized Communication",
        },
        {
          SUB_BENEFIT: "Secure Communication",
        },
        {
          SUB_BENEFIT: "Build Trust",
        },
        {
          SUB_BENEFIT: "Direct Customer Engagement",
        },
        {
          SUB_BENEFIT: "Streamlined Automation",
        },
        {
          SUB_BENEFIT: "Enhanced Customer Loyalty",
        },
      ],
    },
    DESCRIPTION:
      "Leverage our tailored WhatsApp services for instant engagement, boosting communication and cost efficiency. Automate responses and enhance customer support to drive business success.",
  },
  {
    TITLE: "CHATBOT",
    TITLE2: "Chatbots",
    PATH: "/product?name=chat-bots",
    DETAILS: {
      TITLE: "Automate manual work with ChatBots",
      PROJECT_NAME: "CHATBOTS",
      PROJECT_IMG: IMAGES.chatbots,
      PROJECT_URL: "",
      OVER_VIEW: [
        {
          SUB_TITLE:
            "Chatbots have emerged as transformative tools reshaping the way businesses interact with customers and streamline internal processes. These virtual assistants are revolutionizing customer service, sales, and operational efficiency across industries. ",
        },
        {
          SUB_TITLE:
            "By providing instant responses to inquiries, personalized recommendations, and automating tasks, chatbots offer a seamless and efficient way to engage with users. ",
        },
        {
          SUB_TITLE:
            "From enhancing customer engagement to boosting productivity, chatbots are leading the way towards a more streamlined future in business operations. ",
        },
        {
          SUB_TITLE:
            "GreytSpace is ideal for companies looking to enhance collaboration, minimize administrative overhead, and ensure that their meeting spaces are used to their full potential.",
        },
      ],
      KEY_BENEFITS: [
        {
          SUB_BENEFIT:
            "Enhances sales efficiency by simplifying access to SAP S/4HANA processes.",
        },
        {
          SUB_BENEFIT:
            "Allows sales teams to concentrate on customer interactions without distractions.",
        },
        {
          SUB_BENEFIT:
            "Speeds up access to production and process information.",
        },
        {
          SUB_BENEFIT:
            "Reduces the effort involved in routine data retrieval tasks.",
        },
        {
          SUB_BENEFIT:
            "Enhances overall productivity by streamlining information flow.",
        },
        {
          SUB_BENEFIT:
            "Provides real-time access to financial data from SAP or other systems.",
        },
        {
          SUB_BENEFIT:
            "Simplifies financial planning and decision-making processes.",
        },
        {
          SUB_BENEFIT:
            "Offers a quick, user-friendly way to retrieve crucial financial information.",
        },
      ],
    },
    DESCRIPTION:
      "Discover our revolutionary chatbot, designed to transform your production, sales, and finance. Experience seamless automation and data-driven insights, driving innovation and success across your entire business.",
  },
];
